import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'city-tax-app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit {

  @Input() heading: string = '';
  @Input() subHeading: string = '';
  @Input() src: string = '';
  @Input() height: any = '';
  @Input() theme: string = 'light'; // Default theme, can be 'dark' or other values.
  @Input() backgroundcolor: string = 'bg-white'; // Default background class for dark theme.

  constructor() {

  }

  backgroundClass() {
    return {
      [this.backgroundcolor]: this.theme === 'dark' ? this.backgroundcolor : "bg-white" // Use this.color for dynamic class
    };
  }

  ngOnInit(): void {
  }

}
